module.exports = __webpack_public_path__ + "img/ar-r.eb708c92.svg";